import { render } from "./EquipmentInfo.vue?vue&type=template&id=87055a00"
import script from "./EquipmentInfo.vue?vue&type=script&lang=js"
export * from "./EquipmentInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__